import { corporationAtom } from '@/state/atom/corporationAtom';
import { closePanelTabSelector, setPanelSelector, updateParamIsCustomerKnowledgeDrilldown } from '@/state/selector/panelSelector';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import LoadingPanel from '../common/LoadingPanel';
import FirstMessageContent from './element/FirstMessageContent';
import GroupButtonKnowledge from './element/GroupButtonKnowledge';
import InputChatAI from './element/InputChatAI';
import ListMessageChatAI from './element/ListMessageChatAI';
import { getProjectInfo, isValidSearchConditionData, onSubscriptionEventUpdateCorporation, updateChatAIInvalidPreconditionStatus } from './handler/ChatAIHandler';
import { getListMessageChat } from '@/service/chatAIService';

import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import AiAutoConstant from "@/common/constant/AiAutoConstant";
import {showLoadingMouse, hideLoadingMouse} from '@/common/utils/CustomCursor';

import { userAtom, userPermissionToViewKnowledgeAtom } from '@/state/atom/userAtom';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { API, I18n } from "aws-amplify";
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { cloneDeep } from 'lodash';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import DataChangePleaseReloadModal from '../common/modal/DataChangePleaseReloadModal';
import { helpdeskTicketLastUserActionAtom, publicKnowledgeHitNumberTicketAtom } from '@/state/atom/ticketAtom';
import { projectIdListUserIsB2CAtom } from '@/state/atom/projectAtom';
import { openShareLinkTicket } from '../chatThread/handler/MessageHandler';
import './ChatAI.css';

import APIAmplify from '@aws-amplify/api';
import { onAIChatPostCreated } from '@/graphql/subscriptions';
import { PropTypes } from 'prop-types';

ChatAI.propTypes = {
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    tabNameChatAI: PropTypes.any,
    filterKnowledgeListData: PropTypes.any
};

export default function ChatAI(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [listMessageContent, setListMessageContent] = useState([]);
    const [projectInfo, setProjectInfo] = useState({});
    const [titleTicket, setTitleTicket] = useState('');
    const [basicPrompt, setBasicPrompt] = useState('');
    const [promptInternalTicket, setPromptInternalTicket] = useState({});
    const [promptExternalTicket, setPromptExternalTicket] = useState({});
    const [triggerReload, setTriggerReload] = useState('');
    const [isLoadingMessage, setIsLoadingMessage] = useState(true);
    const [currentUserDetail, setCurrentUserDetail] = useRecoilState(userAtom);
    const [isReloadPage, setIsReloadPage] =  useState(false);
    const [userSelectedPrompt, setUserSelectedPrompt] = useState([]);
    const [isEnableBtnSend, setIsEnableBtnSend] = useState(true);
    const [corporationSelected, setCorporationSelected] = useState('');
    const [isInvalidSearchCondition, setIsInvalidSearchCondition] = useState(false);
    const [isUsingKnowledgeService, setIsUsingKnowledgeService] = useState(false);
    const [isOpenPopupKnowledgeOff, setIsOpenPopupKnowledgeOff] = useState(false);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isOpenNotFoundTicketPopup,setIsOpenNotFoundTicketPopup] = useState(false);
    
    const [idOfResponseMessage,setIdOfResponseMessage] = useState('')
    const [showPopupSingleButtonError, setShowPopupSingleButtonError] = useState({
        isShow: false,
        message: I18n.get('MSG-CM-DELETED-CONTENT'),
        confirmTxt: I18n.get('CM-BUTTON-OK')
    });
    const [aiAutoPromptTitle, setAiAutoPromptTitle] = useState('')

    const { enqueueSnackbar } = useSnackbar();

    const corporationDetail = useRecoilValue(corporationAtom);
    const totalTickets = useRecoilValue(publicKnowledgeHitNumberTicketAtom);
    const userPermissionView = useRecoilValue(userPermissionToViewKnowledgeAtom);
    const [projectInuseDetail, setProjectInuseDetail] = useRecoilState(projectInuseDetailAtom);

    const reloadKnowledgeDrilldownIsCustomerParams = useSetRecoilState(updateParamIsCustomerKnowledgeDrilldown);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const setProjectIdListUserIsB2CAtom = useSetRecoilState(projectIdListUserIsB2CAtom);
    const setLastUserAction = useSetRecoilState(helpdeskTicketLastUserActionAtom);
    
    const filterKnowledgeListData = props?.filterKnowledgeListData;
    const chatThreadId = filterKnowledgeListData?.threadId;
    const isAiAutoLog = !!filterKnowledgeListData?.aiAutoLog;


    useEffect(() => {
        let subscription 
        if(corporationSelected){
            subscription = onSubscriptionEventUpdateCorporation(corporationSelected,setIsReloadPage);
        }
       return () => {
        if(subscription){
            subscription?.unsubscribe();
        }
    };
    },[corporationSelected])

    useEffect(() => {
        if (Utils.isEmptyString(chatThreadId)) return;

        const controller = new AbortController();

        if (!Utils.isEmptyString(chatThreadId)) {
            let aiAutoLog = filterKnowledgeListData?.aiAutoLog;
            if (aiAutoLog) {
                setIsLoading(true);
                showLoadingMouse();
            }
            
            getListMessageChat(props?.API, chatThreadId, aiAutoLog?.ticketId).then(result => {
                if (result === false) {
                    closePanelTab({
                        event: null,
                        panelType: Constant.PANEL_TYPE.OPEN_CHAT_AI,
                        panelId: props.panelId,
                        tabId: chatThreadId
                    })
                } 
                result = Utils.sortByCreatedAtAsc(result);

                let threadStatus = result[0]?.threadStatus;
                let tabNameChatAI = props?.tabNameChatAI;
                if (!Utils.isEmptyArray(result)) {
                    // Get Full_TabNameChatAI
                    tabNameChatAI = result[0]?.content;

                    if (aiAutoLog) {
                        aiAutoLog.tabName = result[0].content;
                        setAiAutoPromptTitle(result[0].ticketOutline || '');
                    }
                    let chatHistory = [];
                    let showContentMsg = ['MSG-AI-AUTO-LOG-PAUSE', 'MSG-AI-AUTO-LOG-RETRY', 'MSG-AI-AUTO-LOG-ERROR']
                    result?.forEach(message => {
                        if (message.role === 'user') {
                            let content = message.content;

                            chatHistory.push({
                                isFromMe: true,
                                user: !!aiAutoLog
                                    ? `${message?.creatorName || ''} (オート)`
                                    : Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP,currentUserDetail),
                                dateTime: aiAutoLog ? Utils.getJSTDateTimeYYYY_MM_DDHHMM(message.createdAt) : Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(message.createdAt),
                                content: aiAutoLog && showContentMsg.includes(content) ? I18n.get(content) : content,
                                isHidden: aiAutoLog && content ==='MSG-AI-AUTO-LOG-REPLAY'
                            }); 
                        }else{
                            chatHistory.push({
                                isFromMe: false,
                                dateTime: aiAutoLog ? Utils.getJSTDateTimeYYYY_MM_DDHHMM(message.createdAt) : Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(message.createdAt),
                                content: message.content
                            }); 
                        }
                    });

                    if (aiAutoLog && threadStatus === AiAutoConstant.AICHATTHREAD_LOG_STATUS.RUNNING) {
                        chatHistory.push({
                            isFromMe: false,
                            isLoadingMessage: true
                        })
                    }
                    setListMessageContent([...chatHistory])
                }

                let currentPanelList = cloneDeep(panelList);
                if (Utils.isEmptyArray(currentPanelList)) return;
                let currentPanelIndex = Utils.findIndexInArrayById(props.panelId, currentPanelList);
                if (currentPanelIndex === -1) return;

                let currentPanel = currentPanelList[currentPanelIndex];

                if (Utils.isEmptyArray(currentPanel.tabList)) return;
                let currentTabIndex = Utils.findIndexInArrayById(props.tabId, currentPanel.tabList);
                if (currentTabIndex === -1) return;
                
                // Update ticket outline
                currentPanelList[currentPanelIndex].tabList[currentTabIndex].chatThreadId = chatThreadId;

                //  optimize chatAi tabList
                const optimizeFilterKnowledgeListData = currentPanelList[currentPanelIndex].tabList[currentTabIndex].component.props?.filterKnowledgeListData
                if (optimizeFilterKnowledgeListData && optimizeFilterKnowledgeListData.organizationProject) {
                    delete optimizeFilterKnowledgeListData.organizationProject
                }
                currentPanelList[currentPanelIndex].tabList[currentTabIndex].component.props.filterKnowledgeListData = optimizeFilterKnowledgeListData
                currentPanelList[currentPanelIndex].tabList[currentTabIndex].component.props.tabNameChatAI = tabNameChatAI;
                currentPanelList[currentPanelIndex].tabList[currentTabIndex].tabNameChatAI = tabNameChatAI;

                if (aiAutoLog) {
                    currentPanelList[currentPanelIndex].tabList[currentTabIndex].component.props.tabNameChatAI = aiAutoLog.tabName;
                    currentPanelList[currentPanelIndex].tabList[currentTabIndex].tabNameChatAI = aiAutoLog.tabName;
                }
                
                setPanelList([...currentPanelList]);
            })
            .catch(e => console.log('getListMessageChat err: ', e))
            .finally(() => {
                if (aiAutoLog) {
                    setIsLoading(false);
                    hideLoadingMouse();
                }
            });

        }

        return () => {
            controller.abort();
        }

    }, [chatThreadId, props?.tabId]);

    useEffect(() => {
        let aiAutoLog = filterKnowledgeListData?.aiAutoLog;
        // if (!aiAutoLog) return;
        
        let subscriptionAiAuto;
        const handleSubscriptionCreateAiAutoChatPost = (threadId) => {
            let subscription;
            subscription = APIAmplify.graphql({
                query: onAIChatPostCreated,
                variables: { chatThreadId: threadId },
                authMode: Constant.AUTH_MODE_API_KEY
            }).subscribe({
                next: res => {
                    let newChatPost = res.value.data.onAIChatPostCreated;
                    console.log('subscriptionAiAuto:', {res, newChatPost});
                    if (!aiAutoLog) {
                        if (newChatPost.role !== 'system') return;

                        setListMessageContent(prev => {
                            let listMsg = [...prev];
                            console.log('--- prev >>>', listMsg)
    
                            let createMsg = {
                                dateTime:Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(newChatPost.createdAt),
                                content: newChatPost.content,
                                isFromMe: newChatPost.role === 'user'
                            }
                            const currentLastMsg = listMsg[listMsg.length - 1];

                            if (
                                currentLastMsg &&
                                currentLastMsg.isFromMe === false &&
                                currentLastMsg.isLoadingMessage === true
                            ) {
                                listMsg[listMsg.length - 1] = createMsg;
                                listMsg.push(currentLastMsg);
                            }
    
                            return listMsg;
                        });
                        return;
                    }
                   
                    if (newChatPost.content === 'MSG-AI-AUTO-LOG-PAUSE') {
                        newChatPost.content = I18n.get('MSG-AI-AUTO-LOG-PAUSE')
                    }
                    
                    setListMessageContent(prev => {
                        let listMsg = [...prev];
                        console.log('--- prev >>>', listMsg)

                        let createMsg = {
                            dateTime:Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(newChatPost.createdAt),
                            content: newChatPost.content,
                            isFromMe: newChatPost.role === 'user'
                        }

                        const currentLastMsg = listMsg[listMsg.length - 1];
                        // case: replace msg PAUSE to gpt loading
                        if (
                            currentLastMsg &&
                            currentLastMsg.isFromMe === false &&
                            currentLastMsg.isLoadingMessage === true
                        ) {
                            listMsg[listMsg.length - 1] = createMsg;
                        }
                        // case: push msg Replay & msg gpt loading
                        else if (
                            createMsg.content === 'MSG-AI-AUTO-LOG-REPLAY'
                        ) {
                            createMsg.isHidden = true;
                            listMsg.push(createMsg);
                            listMsg.push({
                                isFromMe: false,
                                isLoadingMessage: true
                            });
                            
                        }
                        else {
                            listMsg.push(createMsg);
                        }
                        console.log('--- return subscriptionAiAuto listMsg :>> ', listMsg);
                        return listMsg;
                    })
                },
                error: error => {
                    console.log('subscriptionAiAuto error:', error);
                }
            });
            return subscription
        }
        if (!Utils.isEmptyString(chatThreadId)) {
            subscriptionAiAuto = handleSubscriptionCreateAiAutoChatPost(
                chatThreadId
            );
        }
        return () => {
            if (subscriptionAiAuto) {
                subscriptionAiAuto?.unsubscribe();
            }
        };
    }, [chatThreadId, props?.tabId]);


    const usingBasicPrompt = filterKnowledgeListData?.hasOwnProperty('usingBasicPrompt')
        ? filterKnowledgeListData.usingBasicPrompt
        : true;
    const resetSearchCondition = filterKnowledgeListData?.hasOwnProperty('resetSearchCondition')
        ? filterKnowledgeListData.resetSearchCondition
        : false;

    const isInvalidPrecondition = filterKnowledgeListData?.hasOwnProperty('isInvalidPrecondition')
        ? filterKnowledgeListData.isInvalidPrecondition
        : false;

    const initHitNumber = filterKnowledgeListData?.hasOwnProperty('hitNumber')
        ? filterKnowledgeListData.hitNumber
        : totalTickets
    
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [toggleUsingKnowledgeTicketList, setToggleUsingKnowledgeTicketList] = useState(!resetSearchCondition);

    useEffect(() => {
        let aiAutoLog = filterKnowledgeListData?.aiAutoLog;
        if (aiAutoLog) return;

        (async () => {
            setIsLoading(true);
            await getProjectInfo(
                props?.API,
                filterKnowledgeListData?.projectIdKnowledgeSelected,
                setProjectInfo,
                corporationDetail,
                setTitleTicket,
                setPromptInternalTicket,
                setPromptExternalTicket,
                setBasicPrompt,
                filterKnowledgeListData,
                setIsReloadPage,
                setCorporationSelected,
                projectInuseDetail.id,
                setIsUsingKnowledgeService,
                setProjectInuseDetail
            );
            setIsLoading(false);
        })();
    }, [
        props?.filterKnowledgeListData?.projectIdKnowledgeSelected,
        triggerReload,
        props?.filterKnowledgeListData?.ticketCreatedProjectId,
        props?.filterKnowledgeListData?.ticketCreatedCorporationId
    ]);
    
    const reOpenKnowledgePanel = async () => {
        setIsLoading(true);
        let isValidCondition = await isValidSearchConditionData(
            props?.API,
            projectInuseDetail,
            props?.filterKnowledgeListData?.projectIdKnowledgeSelected,
            projectInfo,
            props?.filterKnowledgeListData?.viewSelectedId,
            currentUserDetail,
            userPermissionView,
            setProjectIdListUserIsB2CAtom,
            panelList,
            setPanelList
        );

        setIsLoading(false);
        if (!isValidCondition) {
            if (projectInuseDetail.type === Constant.PROJECT_TYPE.CUSTOMER) {
                setIsReloadPage(true);
                return;
            }
            setIsInvalidSearchCondition(true);
            return;
        }

        const existedPanel = panelList.find(panel => (Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST).includes(panel.type));
        if (!Utils.isEmptyObject(existedPanel)) {
            closePanelTab({
                event: null,
                panelType: existedPanel.type,
                panelId: existedPanel.id,
                tabId: 'knowledge_ticket_list_tab'
            });
        }

        const propsClone = cloneDeep(props);
        console.log('--- reOpenKnowledgePanel propsClone', propsClone)
        // delete propsClone.panelId;
        delete propsClone.filterKnowledgeListData;

        let addNewPanelParams = {
            type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
            componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
            tabId: 'knowledge_ticket_list_tab',
            existedKnowledgePanel: existedPanel,
            visibilitySettingType: props?.filterKnowledgeListData?.visibilityKnowledgeAtom ? props?.filterKnowledgeListData?.visibilityKnowledgeAtom : Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
            isCustomer: false,
            projectSelectedId: props?.filterKnowledgeListData.projectIdKnowledgeSelected,
            corporationSelectedId: corporationSelected,
            knowledgeInfoChatAi: {
                viewSelectedId: props?.filterKnowledgeListData.viewSelectedId,
                viewSelected: props?.filterKnowledgeListData.viewSelected,
                viewStructure: props?.filterKnowledgeListData.viewStructure,
                ticketCreatedCorporationId: props?.filterKnowledgeListData.ticketCreatedCorporationId,
                ticketCreatedProjectId: props?.filterKnowledgeListData.ticketCreatedProjectId,
            }, 
            props : {
                ...propsClone,
                componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
                panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
                panelId: propsClone.panelId,
                projectSelectedId: props?.filterKnowledgeListData.projectIdKnowledgeSelected,
                visibilitySettingType: props?.filterKnowledgeListData?.visibilityKnowledgeAtom ? props?.filterKnowledgeListData?.visibilityKnowledgeAtom : props.visibilitySettingType,
                ticketCreatedCorporationId: props?.filterKnowledgeListData.ticketCreatedCorporationId,
                ticketCreatedProjectId: props?.filterKnowledgeListData.ticketCreatedProjectId,
            },
        }

        if (props?.filterKnowledgeListData.projectIdKnowledgeSelected !== projectInuseDetail.id  ) {
            // setIsShowVisibilityKnowledgeAtom(false);
            addNewPanelParams.visibilitySettingType = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
            addNewPanelParams.isCustomer = true
        }

        addNewPanel(addNewPanelParams)

        reloadKnowledgeDrilldownIsCustomerParams({
            isCustomer: addNewPanelParams.isCustomer
        });
    };

    const onClickUrlViewTicket = async (url) => {
        setIsLoading(true)
        const {
            orgDomain: affiliationOrganizationDomain,
            projectId: affiliationProject,
            ticketId: ticketIdOfUrl,
            withMessage
        } = await Utils.extractShareLinkInfo(url);

        await openShareLinkTicket(
            API,
            ticketIdOfUrl,
            affiliationProject,
            affiliationOrganizationDomain,
            currentUserDetail.id,
            projectInuseDetail.id,
            {
                ...props,
                setIsLoading,
                API,
                setIsOpenAccessDeniedPopup,
                setIsOpenPopupKnowledgeOff,
                setIsOpenNotFoundTicketPopup,
                addNewPanel,
                setLastUserAction,
                setPanelList,
                setProjectDetail: setProjectInuseDetail,
                userDetail: currentUserDetail,
                setUserDetail: setCurrentUserDetail,
                setShowPopupSingleButtonError
            },
            withMessage
        );
    }
    window.onClickUrlViewTicket = onClickUrlViewTicket;

    return (
        <div className="chat-ai-container">
            <LoadingPanel isLoading={isLoading} />
            <FirstMessageContent tabNameChatAI={props?.tabNameChatAI} />
            {!isAiAutoLog && (
                <GroupButtonKnowledge
                    projectInfo={projectInfo}
                    panelId={props.panelId}
                    tabId={props.tabId}
                    resetSearchCondition={resetSearchCondition}
                    isInvalidPrecondition={isInvalidPrecondition}
                    viewSelectedIdInProps={filterKnowledgeListData?.viewSelectedId}
                    viewStructure={filterKnowledgeListData?.viewStructure}
                    API={props?.API}
                    setIsLoading={setIsLoading}
                    enqueueSnackbar={enqueueSnackbar}
                    reOpenKnowledgePanel={reOpenKnowledgePanel}
                    projectIdKnowledgeSelected={filterKnowledgeListData?.projectIdKnowledgeSelected}
                    tabNameChatAI={props?.tabNameChatAI}
                    corporationSelected={corporationSelected}
                    initHitNumber={initHitNumber}
                    isUsingKnowledgeService={isUsingKnowledgeService}
                    toggleUsingKnowledgeTicketList={toggleUsingKnowledgeTicketList}
                    setToggleUsingKnowledgeTicketList={setToggleUsingKnowledgeTicketList}
                />
            )}

            <div className="group-chat-input">
                <ListMessageChatAI
                    listMessageContent={listMessageContent}
                    setIsLoadingMessage={setIsLoadingMessage}
                    isLoadingMessage={isLoadingMessage}
                    chatThreadId={chatThreadId}
                    isEnableBtnSend={isEnableBtnSend}
                    setIsEnableBtnSend={setIsEnableBtnSend}
                    setListMessageContent={setListMessageContent}
                    panelId={props.panelId}
                    corporationDetail={corporationDetail}
                    currentUserDetail={currentUserDetail}
                    setUserSelectedPrompt={setUserSelectedPrompt}
                    idOfResponseMessage={idOfResponseMessage}
                    setIdOfResponseMessage={setIdOfResponseMessage}
                    projectInfo={projectInfo}
                    projectInuseDetail={projectInuseDetail}
                    isAiAutoLog={isAiAutoLog}
                    aiAutoPromptTitle={aiAutoPromptTitle}
                />
                {!isAiAutoLog && (
                    <InputChatAI
                        setListMessageContent={setListMessageContent}
                        panelId={props.panelId}
                        tabId={props.tabId}
                        API={props?.API}
                        projectInfo={projectInfo}
                        setTriggerReload={setTriggerReload}
                        filterKnowledgeListData={filterKnowledgeListData}
                        basicPrompt={basicPrompt}
                        isEnableBtnSend={isEnableBtnSend}
                        setIsEnableBtnSend={setIsEnableBtnSend}
                        listMessageContent={listMessageContent}
                        resetSearchCondition={resetSearchCondition}
                        corporationSelected={corporationSelected}
                        tabNameChatAI={props?.tabNameChatAI}
                        titleTicket={titleTicket}
                        setUserSelectedPrompt={setUserSelectedPrompt}
                        userSelectedPrompt={userSelectedPrompt}
                        promptInternalTicket={promptInternalTicket}
                        promptExternalTicket={promptExternalTicket}
                        setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        usingBasicPrompt={usingBasicPrompt}
                        idOfResponseMessage={idOfResponseMessage}
                        setIdOfResponseMessage={setIdOfResponseMessage}
                        isUsingKnowledgeServiceValue={isUsingKnowledgeService}
                        toggleUsingKnowledgeTicketList={toggleUsingKnowledgeTicketList}
                    />
                )}
            </div>
            <ConfirmDialog
                isOpen={isReloadPage}
                msgConfirm={I18n.get('COMMSG030')}
                okCallBack={() => window.location.reload()}
            />

            <ConfirmDialog
                isOpen={isInvalidSearchCondition}
                msgConfirm={I18n.get('MSG-ERROR-WHEN-KNOWLEDGE-BEING-USED-BE-HIDDEN-OR-DELETED')}
                okCallBack={() => {
                    updateChatAIInvalidPreconditionStatus(
                        panelList,
                        setPanelList,
                        props.panelId,
                        props.tabId,
                        true
                    );
                    setIsInvalidSearchCondition(false);
                }}
            />

            <DataChangePleaseReloadModal
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
            <ConfirmDialog
                isOpen={isOpenPopupKnowledgeOff}
                msgConfirm={I18n.get('USER14MSG028')}
                okCallBack={e => {
                    setIsOpenPopupKnowledgeOff(false);
                }}
                textSubmit={'はい'}
            />
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={I18n.get('KNOWDEMSG005')}
                okCallBack={e => setIsOpenAccessDeniedPopup(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isOpenNotFoundTicketPopup}
                msgConfirm={I18n.get('MSG-CM-DELETED-CONTENT')}
                okCallBack={e => setIsOpenNotFoundTicketPopup(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={showPopupSingleButtonError?.isShow}
                msgConfirm={showPopupSingleButtonError?.message}
                okCallBack={e =>
                    setShowPopupSingleButtonError(pre => {
                        return {
                            ...pre,
                            isShow: false
                        };
                    })
                }
                textSubmit={showPopupSingleButtonError?.confirmTxt}
            />
        </div>
    );
}
